import { memo } from 'react';
import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { EventRenderer } from './event-renderer';

interface Props {
  columnId: string;
}

const ColumnEventsComponent = ({ columnId }: Props) => {
  const columnInfo = useCalendarGridStore((s) => s.columnsById[columnId]);

  if (!columnInfo?.eventIds.length) return null;

  return columnInfo.eventIds.map((eventId) => <EventRenderer key={eventId} eventId={eventId} />);
};

export const ColumnEvents = memo(ColumnEventsComponent);
